import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import config from "../../config";
import "../../Style/header.css";
import waIcon from "../../assets/images/whatsappicon.png";
import call from "../../assets/images/call.icon.png";
import Icon from "../../assets/images/callIcon.png";
import phone from "../../assets/images/phone.png";
import image from "../../assets/images/phoneImage.png";
import insta from "../../assets/images/Instagram_icon.png";
import certificate from "../../assets/images/certificatefooter.jpg";
import creditcard from "../../assets/images/credit-card.png";
import cards from "../../assets/images/Group 1000004654.png";
import TransferServiceModal from "../transferService/TransferServiceModal";

const Footer = () => {
  const [categories, setCategories] = useState([]);
  const currentYear = new Date().getFullYear();
  const [showTransferModal, setShowTransferModal] = useState(false);

  // const [showChat, setShowChat] = useState(false);

  // Load chat widget script and fetch categories
  // useEffect(() => {
  //     const loadJivosite = () => {
  //         const widgetId = 'Ajwd8F0W7H';
  //         const script = document.createElement('script');
  //         script.src = `//code.jivosite.com/script/widget/${widgetId}`;
  //         script.async = true;

  //         document.body.appendChild(script);
  //     };

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await fetch(
          `${config.baseUrl}/categories/footer-list`,
        );
        const data = await response.json();
        if (data && Array.isArray(data.data)) {
          setCategories(data.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategories();
  }, []);

  // const fetchCategories = async () => {
  //     try {
  //         const response = await fetch(`${config.baseUrl}/categories/cat-list`);
  //         const data = await response.json();

  //         if (data && data.data && Array.isArray(data.data)) {
  //             setCategories(data.data);
  //         } else {
  //             console.error('No categories found in the response:', data);
  //             setCategories([]); // Set to an empty array if 'data.data' is not present, not an array, or undefined
  //         }
  //     } catch (error) {
  //         console.error('Error fetching categories:', error);
  //     }
  // };

  // useEffect(() => {
  //     fetchCategories();
  // }, []);

  //     setShowChat(true);

  //     if (showChat) {
  //         loadJivosite();
  //     }
  // }, [showChat]);

  const chunkSize = Math.ceil(categories.length / 3);
  const col1 = categories.slice(0, chunkSize);
  const col2 = categories.slice(chunkSize, chunkSize * 2);
  const col3 = categories.slice(chunkSize * 2);

  return (
    <>
      <footer>
        <div className="floating-contact-icons">
          <div className="WhatsappIconDiv">
            <Link to="https://wa.me/+971559554333" target="_blank">
              <svg
                width="39"
                height="39"
                viewBox="0 0 39 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  className="color-element"
                  cx="19.4395"
                  cy="19.4395"
                  r="19.4395"
                  fill="#49E670"
                ></circle>
                <path
                  d="M12.9821 10.1115C12.7029 10.7767 11.5862 11.442 10.7486 11.575C10.1902 11.7081 9.35269 11.8411 6.84003 10.7767C3.48981 9.44628 1.39593 6.25317 1.25634 6.12012C1.11674 5.85403 2.13001e-06 4.39053 2.13001e-06 2.92702C2.13001e-06 1.46351 0.83755 0.665231 1.11673 0.399139C1.39592 0.133046 1.8147 1.01506e-06 2.23348 1.01506e-06C2.37307 1.01506e-06 2.51267 1.01506e-06 2.65226 1.01506e-06C2.93144 1.01506e-06 3.21063 -2.02219e-06 3.35022 0.532183C3.62941 1.19741 4.32736 2.66092 4.32736 2.79397C4.46696 2.92702 4.46696 3.19311 4.32736 3.32616C4.18777 3.59225 4.18777 3.59224 3.90858 3.85834C3.76899 3.99138 3.6294 4.12443 3.48981 4.39052C3.35022 4.52357 3.21063 4.78966 3.35022 5.05576C3.48981 5.32185 4.18777 6.38622 5.16491 7.18449C6.42125 8.24886 7.39839 8.51496 7.81717 8.78105C8.09636 8.91409 8.37554 8.9141 8.65472 8.648C8.93391 8.38191 9.21309 7.98277 9.49228 7.58363C9.77146 7.31754 10.0507 7.1845 10.3298 7.31754C10.609 7.45059 12.2841 8.11582 12.5633 8.38191C12.8425 8.51496 13.1217 8.648 13.1217 8.78105C13.1217 8.78105 13.1217 9.44628 12.9821 10.1115Z"
                  transform="translate(12.9597 12.9597)"
                  fill="#FAFAFA"
                ></path>
                <path
                  d="M0.196998 23.295L0.131434 23.4862L0.323216 23.4223L5.52771 21.6875C7.4273 22.8471 9.47325 23.4274 11.6637 23.4274C18.134 23.4274 23.4274 18.134 23.4274 11.6637C23.4274 5.19344 18.134 -0.1 11.6637 -0.1C5.19344 -0.1 -0.1 5.19344 -0.1 11.6637C-0.1 13.9996 0.624492 16.3352 1.93021 18.2398L0.196998 23.295ZM5.87658 19.8847L5.84025 19.8665L5.80154 19.8788L2.78138 20.8398L3.73978 17.9646L3.75932 17.906L3.71562 17.8623L3.43104 17.5777C2.27704 15.8437 1.55796 13.8245 1.55796 11.6637C1.55796 6.03288 6.03288 1.55796 11.6637 1.55796C17.2945 1.55796 21.7695 6.03288 21.7695 11.6637C21.7695 17.2945 17.2945 21.7695 11.6637 21.7695C9.64222 21.7695 7.76778 21.1921 6.18227 20.039L6.17557 20.0342L6.16817 20.0305L5.87658 19.8847Z"
                  transform="translate(7.7758 7.77582)"
                  fill="white"
                  stroke="white"
                  stroke-width="0.2"
                ></path>
              </svg>
            </Link>
          </div>

          <div className="CallIconDiv">
            <Link to="tel:+97143961444">
              <svg
                width="39"
                height="39"
                viewBox="0 0 39 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  className="color-element"
                  cx="19.4395"
                  cy="19.4395"
                  r="19.4395"
                  fill="#03E78B"
                ></circle>
                <path
                  d="M19.3929 14.9176C17.752 14.7684 16.2602 14.3209 14.7684 13.7242C14.0226 13.4259 13.1275 13.7242 12.8292 14.4701L11.7849 16.2602C8.65222 14.6193 6.11623 11.9341 4.47529 8.95057L6.41458 7.90634C7.16046 7.60799 7.45881 6.71293 7.16046 5.96705C6.56375 4.47529 6.11623 2.83435 5.96705 1.34259C5.96705 0.596704 5.22117 0 4.47529 0H0.745882C0.298353 0 5.69062e-07 0.298352 5.69062e-07 0.745881C5.69062e-07 3.72941 0.596704 6.71293 1.93929 9.3981C3.87858 13.575 7.30964 16.8569 11.3374 18.7962C14.0226 20.1388 17.0061 20.7355 19.9896 20.7355C20.4371 20.7355 20.7355 20.4371 20.7355 19.9896V16.4094C20.7355 15.5143 20.1388 14.9176 19.3929 14.9176Z"
                  transform="translate(9.07179 9.07178)"
                  fill="white"
                ></path>
              </svg>
            </Link>
          </div>

          <div className="EmailIconDiv">
            <Link to="mailto:dubaiprivatetour@gmail.com">
              <svg
                width="39"
                height="39"
                viewBox="0 0 39 39"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <circle
                  className="color-element"
                  cx="19.4395"
                  cy="19.4395"
                  r="19.4395"
                  fill="#FF485F"
                ></circle>
                <path
                  d="M20.5379 14.2557H1.36919C0.547677 14.2557 0 13.7373 0 12.9597V1.29597C0 0.518387 0.547677 0 1.36919 0H20.5379C21.3594 0 21.9071 0.518387 21.9071 1.29597V12.9597C21.9071 13.7373 21.3594 14.2557 20.5379 14.2557ZM20.5379 12.9597V13.6077V12.9597ZM1.36919 1.29597V12.9597H20.5379V1.29597H1.36919Z"
                  transform="translate(8.48619 12.3117)"
                  fill="white"
                ></path>
                <path
                  d="M10.9659 8.43548C10.829 8.43548 10.692 8.43548 10.5551 8.30588L0.286184 1.17806C0.012346 0.918864 -0.124573 0.530073 0.149265 0.270879C0.423104 0.0116857 0.833862 -0.117911 1.1077 0.141283L10.9659 7.00991L20.8241 0.141283C21.0979 -0.117911 21.5087 0.0116857 21.7825 0.270879C22.0563 0.530073 21.9194 0.918864 21.6456 1.17806L11.3766 8.30588C11.2397 8.43548 11.1028 8.43548 10.9659 8.43548Z"
                  transform="translate(8.47443 12.9478)"
                  fill="white"
                ></path>
                <path
                  d="M9.0906 7.13951C8.95368 7.13951 8.81676 7.13951 8.67984 7.00991L0.327768 1.17806C-0.0829894 0.918864 -0.0829899 0.530073 0.190849 0.270879C0.327768 0.0116855 0.738525 -0.117911 1.14928 0.141282L9.50136 5.97314C9.7752 6.23233 9.91212 6.62112 9.63828 6.88032C9.50136 7.00991 9.36444 7.13951 9.0906 7.13951Z"
                  transform="translate(20.6183 18.7799)"
                  fill="white"
                ></path>
                <path
                  d="M0.696942 7.13951C0.423104 7.13951 0.286185 7.00991 0.149265 6.88032C-0.124573 6.62112 0.012346 6.23233 0.286185 5.97314L8.63826 0.141282C9.04902 -0.117911 9.45977 0.0116855 9.59669 0.270879C9.87053 0.530073 9.73361 0.918864 9.45977 1.17806L1.1077 7.00991C0.970781 7.13951 0.833862 7.13951 0.696942 7.13951Z"
                  transform="translate(8.47443 18.7799)"
                  fill="white"
                ></path>
              </svg>
            </Link>
          </div>

          <div className="InstagramIconDiv">
            <Link
              to="https://www.instagram.com/dubaiprivatetour/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="39"
                height="39"
                viewBox="0 0 39 39"
                xmlns="http://www.w3.org/2000/svg"
              >
                <defs>
                  <radialGradient
                    id="instaGradient"
                    cx="30%"
                    cy="107%"
                    r="150%"
                  >
                    <stop offset="0%" stopColor="#fdf497" />
                    <stop offset="5%" stopColor="#fdf497" />
                    <stop offset="45%" stopColor="#fd5949" />
                    <stop offset="60%" stopColor="#d6249f" />
                    <stop offset="90%" stopColor="#285AEB" />
                  </radialGradient>
                </defs>

                <circle
                  cx="19.5"
                  cy="19.5"
                  r="19.5"
                  fill="url(#instaGradient)"
                />

                <path
                  d="M19.5 12.5c-3.8 0-6.9 3.1-6.9 6.9s3.1 6.9 6.9 6.9 6.9-3.1 6.9-6.9-3.1-6.9-6.9-6.9zm0 11.3a4.4 4.4 0 110-8.8 4.4 4.4 0 010 8.8z"
                  fill="white"
                />

                <circle cx="26.5" cy="12.8" r="1.4" fill="white" />

                <path
                  d="M25.7 7H13.3C9.9 7 7 9.9 7 13.3v12.4C7 29.1 9.9 32 13.3 32h12.4c3.4 0 6.3-2.9 6.3-6.3V13.3C32 9.9 29.1 7 25.7 7zm4.1 18.7c0 2.2-1.8 4-4.1 4H13.3c-2.3 0-4.1-1.8-4.1-4V13.3c0-2.3 1.8-4.1 4.1-4.1h12.4c2.3 0 4.1 1.8 4.1 4.1v12.3z"
                  fill="white"
                />
              </svg>
            </Link>
          </div>
        </div>

        <div className="followUs">
          <div className="container">
            <div className="followtext">Follow us on</div>
            <ul>
              <li>
                <Link
                  to="https://www.facebook.com/DubaiPrivateTour"
                  className="fb"
                  target="_blank"
                ></Link>
              </li>
              <li>
                <Link
                  to="https://twitter.com/i/flow/login?redirect_after_login=%2Fdubaipvttour"
                  className="tw"
                  target="_blank"
                ></Link>
              </li>
              <li>
                <Link
                  to="https://www.youtube.com/channel/UC1b7fJBbKWpHYMUnNQ5XTCA"
                  className="yt"
                  target="_blank"
                ></Link>
              </li>
              <li>
                <Link
                  to="https://www.instagram.com/dubaiprivatetour/"
                  className="ig"
                  target="_blank"
                ></Link>
              </li>
            </ul>
          </div>
        </div>
        <div className="container">
          <div className="menuWrapper">
            <div className="footerWidget">
              <h6>Get In Touch</h6>
              <p>
                Al Makhawi Building, 1st Floor, Office No 117, Umm Hurair Road,
                PB 120730 - Dubai - United Arab Emirates
              </p>
              <div className="fInfo">
                <a href="tel:+97143961444" className="call">
                  +971559554333 
                </a>
                <a href="tel:+97143961444" className="call">
                  +97143961444
                </a>
                <a href="mailto:info@milantoursdubai.com" className="mail">
                  info@dubaiprivatetour.com
                </a>
                <a href="mailto:info@milantoursdubai.com" className="mail">
                  info@milantoursdubai.com
                </a>
              </div>
            </div>
            {/* <div className="footerWidget">
                        <h6>Tours & Safaris</h6>
                        <ul>
                            {categories.slice(0, 8).map((item, index) => (
                                <li key={index}>
                                    <Link to={`/${item.slug}`}>{item.name}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="footerWidget">
                        <ul>
                            {categories.slice(8, 16).map((item, index) => (
                                <li key={index}>
                                    <Link to={`/${item.slug}`}>{item.name}</Link>
                                </li>
                            ))}
                        </ul>
                    </div>
                    <div className="footerWidget">
                        <ul>
                            {categories.slice(16, 24).map((item, index) => (
                                <li key={index}>
                                    <Link to={`/${item.slug}`}>{item.name}</Link>
                                </li>
                            ))}
                        </ul>
                    </div> */}

            <div className="footerWidget">
              <h6>Tours & Safaris</h6>
              <ul>
                {col1.map((item, index) => (
                  <li key={index}>
                    <Link to={`/${item.slug}`}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footerWidget">
              <ul>
                {col2.map((item, index) => (
                  <li key={index}>
                    <Link to={`/${item.slug}`}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            </div>

            <div className="footerWidget">
              <ul>
                {col3.map((item, index) => (
                  <li key={index}>
                    <Link to={`/${item.slug}`}>{item.name}</Link>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="footerlogoWrapper">
            <div className="footerlogoLhs">
              <Link to="#">
                <img
                  src={
                    "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698738421/footerimg1_zar3zu.png"
                  }
                  alt=""
                  target="_blank"
                />
              </Link>
              <Link
                to="https://www.tripadvisor.com/Attraction_Review-g295424-d2510773-Reviews-Dubai_Private_Tour-Dubai_Emirate_of_Dubai.html"
                target="_blank"
              >
                <img
                  src={
                    "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698738422/footerimg2_ywzywb.png"
                  }
                  alt=""
                />
              </Link>
              {/* <Link to="#">
                            <img src={"https://res.cloudinary.com/dqslvlm0d/image/upload/v1698738420/footerimg3_taqggo.png"} alt="" target="_blank" />
                        </Link> */}
              <Link to="#">
                <img src={certificate} alt="caerticate image" target="_blank" />
              </Link>
              <Link to="#">
                <img
                  src={
                    "https://res.cloudinary.com/dqslvlm0d/image/upload/v1698738419/footerimg4_b8gxe1.png"
                  }
                  alt=""
                  target="_blank"
                />
              </Link>
            </div>
            <div className="footerlogoRhs">
              {/* <Link to="/">
                            <img src={"https://res.cloudinary.com/dqslvlm0d/image/upload/v1698738575/card1_c52961.png"} alt="" target="_blank" />
                        </Link>
                        <Link to="/">
                            <img src={"https://res.cloudinary.com/dqslvlm0d/image/upload/v1698738574/card2_fzycza.png"} alt="" />
                        </Link>
                        <Link to="/">
                            <img src={"https://res.cloudinary.com/dqslvlm0d/image/upload/v1698738572/card3_riwt8n.png"} alt="" />
                        </Link> */}
              <Link to="/">
                <img src={cards} alt="cards image" />
              </Link>
              {/* <Link to="/">
                            <img src={creditcard} alt="cards image" />
                        </Link> */}
            </div>
          </div>
          <div className="footerMenu">
            <ul>
              <li>
                <Link to="/contact-us">Contact us</Link>
              </li>
              <li>
                <Link to="/about-us">About us</Link>
              </li>
              <li>
                <Link to="https://www.dubaiprivatetour.com/blog/">Blogs</Link>
              </li>
              {/* <li>
                <button
                  type="button"
                  className="footer-link-btn"
                  onClick={() => {
                    console.log("Transfer modal clicked");
                    setShowTransferModal(true);
                  }}
                >
                  Transfer Service
                </button>
              </li> */}
            </ul>
          </div>
          <div className="footerMenuBorder"></div>
          <div className="footerBottom">
            <div className="footerBottomLhs">
              <p>Copyright {currentYear}. All Rights Reserved.</p>
            </div>
            <div className="footerBottomRhs">
              <Link to="/privacy-policy">Privacy Policy</Link>
              {/* <Link to="/term-condition">Terms & Conditions</Link> */}
              <Link to="/cancellation-policy">Cancellation Policy</Link>
            </div>
          </div>
        </div>
        {/* {showChat && (
                <div
                    style={{
                        position: "fixed",
                        bottom: "20px",
                        right: "20px",
                        zIndex: "1000"
                    }}
                > */}
        {/* Add Jivosite chat script directly */}
        {/* <script
                        dangerouslySetInnerHTML={{
                            __html: `
                                (function(){ var widget_id = 'Ajwd8F0W7H';
                                var d=document;var w=window;function l(){
                                var s = document.createElement('script'); s.type = 'text/javascript'; s.async = true; s.src = '//code.jivosite.com/script/widget/'+widget_id; var ss = document.getElementsByTagName('script')[0]; ss.parentNode.insertBefore(s, ss);}if(d.readyState=='complete'){l();}else{if(w.attachEvent){w.attachEvent('onload',l);}else{w.addEventListener('load',l,false);}}})();
                            `
                        }}
                    />
                </div>
            )} */}
      </footer>
      {showTransferModal && (
        <TransferServiceModal onClose={() => setShowTransferModal(false)} />
      )}
    </>
  );
};

export default Footer;
